import { InputField, H1 } from 'base-components';
import { withI18n, Trans } from 'lingui-react';
import PropTypes from 'prop-types';
import React from 'react';
import { compose, setDisplayName } from 'recompose';
import { Row, Column } from 'styled-components-reactive-grid';

import Panel from 'blocks/Panel';

import { DEALER_SEARCH_VALUE } from './constants';
import { Consumer } from './DealerSearchContext';
import withSearchParamUpdater from './withSearchParamUpdater';

function Input({ dealerSearchValue, i18n, onChangeDealerSearchValue }) {
  return (
    <Panel modifiers={['padScale_5']}>
      <Row>
        <Column modifiers={['col', 'padScaleX_4', 'padScaleY_2']}>
          <H1 modifiers={['fontWeightLight']}>
            <Trans>Find Service Provider</Trans>
          </H1>
        </Column>
      </Row>
      <Row>
        <Column modifiers={['col', 'padScaleX_4', 'padScaleY_2']}>
          <InputField
            onChange={event => onChangeDealerSearchValue(event.target.value)}
            placeholder={i18n.t`Search by service provider name...`}
            value={dealerSearchValue}
          >
            <InputField.Icon name="search" />
            <Column modifiers={['col', 'padScale_0']}>
              <Row>
                <InputField.Label>
                  <Trans>Service Provider</Trans>
                </InputField.Label>
              </Row>
              <Row>
                <InputField.TextField autoFocus />
                {dealerSearchValue && (
                  <InputField.ActionButton
                    icon="times"
                    modifiers={['padScaleX_1', 'hoverDanger']}
                    onClick={() => onChangeDealerSearchValue()}
                  />
                )}
              </Row>
            </Column>
          </InputField>
        </Column>
      </Row>
    </Panel>
  );
}

Input.propTypes = {
  dealerSearchValue: PropTypes.string,
  i18n: PropTypes.shape({
    t: PropTypes.func.isRequired,
  }).isRequired,
  onChangeDealerSearchValue: PropTypes.func.isRequired,
};

Input.defaultProps = {
  dealerSearchValue: '',
};

/* istanbul ignore next */
const InputWithConsumerProps = componentProps => (
  <Consumer>
    {({
      [DEALER_SEARCH_VALUE]: dealerSearchValue,
      updateDealerSearchContext,
    }) => {
      const onChangeDealerSearchValue = (value = '') =>
        updateDealerSearchContext({ [DEALER_SEARCH_VALUE]: value });

      return (
        <Input
          {...componentProps}
          dealerSearchValue={dealerSearchValue}
          onChangeDealerSearchValue={onChangeDealerSearchValue}
        />
      );
    }}
  </Consumer>
);

export default compose(
  setDisplayName('Input'),
  withI18n(),
  withSearchParamUpdater,
)(InputWithConsumerProps);



// WEBPACK FOOTER //
// ./src/compositions/TechAdmin/DealerSearch/Input.js